import { Navigate, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Loading } from './components/ui';
import AuthPage from './pages/AuthPage';
import AcceptInvite from './pages/AcceptInvite';
import Onboarding from './pages/Onboarding';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import AppShell from './pages/AppShell';
import Team from './pages/Team';
import Contacts from './pages/Contacts';
import ContactDetail from './pages/ContactDetail';
import Pipeline from './pages/Pipeline';
import Tasks from './pages/Tasks';
import Settings from './pages/Settings';
import Usage from './pages/Usage';
import Admin from './pages/Admin';
import LeadFinder from './pages/tools/LeadFinder';
import Caller from './pages/tools/Caller';
import Email from './pages/tools/Email';
import Content from './pages/tools/Content';
import WalkIn from './pages/tools/WalkIn';

export default function App() {
  const { me, loading } = useAuth();
  if (loading) {
    return (
      <div className="grid h-full place-items-center">
        <Loading label="Starting…" />
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/login" element={me ? <Navigate to="/contacts" replace /> : <AuthPage />} />

      <Route element={<RequireAuth />}>
        {/* Full-screen (no sidebar) */}
        <Route path="/onboarding" element={<Onboarding />} />
        <Route path="/" element={<Home />} />
        <Route path="/pricing" element={<Pricing />} />

        {/* Inside the app shell (sidebar) */}
        <Route element={<AppShell />}>
          {/* Dashboard retired (Phase 10): Contacts is the home base. Keep the old
              path alive as a redirect so bookmarks/links don't 404. */}
          <Route path="/crm" element={<Navigate to="/contacts" replace />} />
          <Route path="/pipeline" element={<Pipeline />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/contacts/:id" element={<ContactDetail />} />
          <Route path="/tasks" element={<Tasks />} />
          <Route path="/tools/lead-finder" element={<LeadFinder />} />
          <Route path="/tools/caller" element={<Caller />} />
          <Route path="/tools/email" element={<Email />} />
          <Route path="/tools/content" element={<Content />} />
          <Route path="/tools/walkin" element={<WalkIn />} />
          <Route path="/team" element={<Team />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/usage" element={<Usage />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Route>
    </Routes>
  );
}

function RequireAuth() {
  const { me } = useAuth();
  const location = useLocation();
  if (!me) return <Navigate to="/login" replace state={{ from: location }} />;

  const needsOnboarding = me.role === 'owner' && !!me.group && !me.group.onboardingCompleted;
  const onOnboarding = location.pathname === '/onboarding';
  if (needsOnboarding && !onOnboarding) return <Navigate to="/onboarding" replace />;
  if (!needsOnboarding && onOnboarding) return <Navigate to="/contacts" replace />;

  return <Outlet />;
}
